<div
  title="{{ 'TOOLTIP.SUMMARYDIALOG' | translate }}"
  class="main"
  fxLayout="column"
  (click)="openSummaryDialog()"
  [inlineSVG]="'assets/svg/icon-readonly.svg'"></div>

<div
  *ngIf="active"
  class="dialog-background"
  (click)="closeSummaryDialog()"
  fxLayout="row"
  fxLayoutAlign="center center">
  <div (click)="eventNinja($event)" class="dialog">
    <div
      class="icon"
      [inlineSVG]="'assets/svg/close.svg'"
      [setSVGAttributes]="{ width: 40, height: 40 }"
      (click)="closeSummaryDialog()"></div>
    <div fxLayout="column" class="content">
      <app-summary></app-summary>
    </div>
  </div>
</div>
